var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`min-height: 80vh; height: 100%;`)},[_c('div',{staticClass:"container md:mx-auto mx-0 p-20 bg-white md:rounded"},[_c('div',{staticClass:"flex items-center justify-center text-center font-semibold"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('payments.welcome'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }